//
import { ModuleLayout } from '@/components/reusable_components/next'
import CustomerList from '@/views/Customer/CustomerList'
import CustomerCreate from '@/views/Customer/CustomerCreate'
import CustomerShowEdit from '@/views/Customer/CustomerShowEdit'
import CustomerMainTabs from '@/views/Customer/CustomerMainTabs'
//
export default {
    path: 'customers',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'customers_list',
            component: CustomerList,
        },
        {
            path: 'create',
            name: 'customers_create',
            component: CustomerCreate,
            meta: {
                title: 'Crear cliente'
            },
        },
        {
            path: ':id',
            name: 'CustomerShowEdit',
            component: CustomerMainTabs,
            meta: {
                title: 'Detalles del cliente'
            },
        },
        // {
        //     path: 'change/:id',
        //     name: 'customer-update',
        //     component: CustomerMainTabs,
        //     meta: {
        //         title: 'Detalles del cliente',
        //     }
        // }
    ],
    meta: {
        title: 'Clientes'
    },
}